import { Chart } from 'primereact/chart';
import React, { Component, PureComponent } from 'react';
import MaterialTable from '@material-table/core';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';

export class AnalyticsProjectReport extends PureComponent {
    columns = [
        { title: 'Проект', field: 'name' },
        { title: 'Контрагент', field: 'account' },
        { title: 'План', field: 'count' }
    ];

    chart = {};

    constructor(props) {
        super(props);

        this.state = {
            selectedStages: "",
            initialPage: 0,
            loading: false,
            stackedData: {
                labels: [],
                datasets: []
            },

            stackedOptions: {
                tooltips: {
                    mode: 'index',
                    intersect: true
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                onClick: this.onGraphClick(this),
                legend: {
                    onClick: (evt, legendItem) =>
                    {
                        var ci = this.chart.current.chart;
                        var index = legendItem.datasetIndex;
                        var meta = this.chart.current.chart.getDatasetMeta(index);
                        meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                        ci.data.datasets[index].hidden = !ci.data.datasets[index].hidden;
                        ci.update();

                        if (this.state.currentAnalyticId) {
                            var stages = "";

                            ci.data.datasets.forEach(element => {
                                if (!element.hidden) {
                                    stages = stages + element.label + ","
                                }
                            });

                            this.setState({ initialPage: 0, selectedStages: stages }, () => this.loadByStateReport(this.state.currentAnalyticId));
                        }
                    }
                }
            },

            projects: []
        };

        this.loadProjects = this.loadProjects.bind(this);
        this.onGraphClick = this.onGraphClick.bind(this);
        this.loadByStateReport = this.loadByStateReport.bind(this);
        this.handleProjectEdit = this.handleProjectEdit.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }

    onGraphClick = scope => (arg1, elements) => {
        if (elements && elements[0]) {
            var stages = "";

            elements.forEach(element => {
                if (element._datasetIndex > 0) {
                    stages = stages + scope.state.stackedData.datasets[element._datasetIndex].label + ","
                    //stages.push()
                }
            });

            console.log(stages);
            var analyticId = scope.state.ids[elements[0]._index];
            this.setState({ currentAnalyticId: scope.state.ids[elements[0]._index], currentAnalytic: scope.state.stackedData.labels[elements[0]._index], initialPage: 0, selectedStages: stages }, () => scope.loadByStateReport(analyticId));
        }
    }

    loadByStateReport(analyticId) {
        var scope = this;
        //scope.setState({ loading: true });

        var token = localStorage.getItem("token");

        fetch('api/Report/GetAnalyticProjectByState?analyticId=' + analyticId + '&state=' + this.state.selectedStages, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ loading: false });
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ projects: result, loading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    componentDidMount() {
        this.loadProjects();
    }

    loadProjects() {
        var scope = this;
        scope.setState({ loading: true });
        var token = localStorage.getItem("token");
        fetch('api/Report/GetAnalyticsProject', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    var stackedData = scope.state.stackedData;
                    stackedData.labels = result.labels;
                    stackedData.datasets = result.datasets.map(dataset => {
                        return {
                            type: 'bar',
                            label: dataset.label,
                            backgroundColor: !!dataset.color ? dataset.color : scope.getRandomColor(),
                            data: dataset.amounts
                        }
                        });

                    stackedData.datasets[0].type = 'line';
                    stackedData.datasets[0].borderColor = '#2196F3';
                    stackedData.datasets[0].borderWidth = 2;
                    stackedData.datasets[0].fill = false;

                    scope.setState({ stackedData: stackedData, loading: false, ids: result.ids });
                }).catch((err) => console.log(err));
            }
        });
    }

    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    handleProjectEdit(rowData) {
        var scope = this;
        //scope.setState({ loading: true });
        var token = localStorage.getItem("token");
        fetch('api/Project/GetProjectMainInfo?id=' + rowData.id, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    scope.setState({ loading: false });
                    MainStore.openProjectDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    onChangePage(page) {
        this.setState({ initialPage: page});
    }

    render() {
        return (
            <div style={{"width": "100%"}}>
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <>
                    <div className="report-block clearfix">
                        <Chart ref={this.chart} type="bar" data={this.state.stackedData} options={this.state.stackedOptions} />
                    </div>
                    <div className="report-block">
                        <b>{this.state.currentAnalytic}</b>
                        {this.state.projects.length > 0 && <MaterialTable
                            title=""
                            columns={this.columns}
                            options={{
                                initialPage: this.state.initialPage
                            }}
                            onChangePage={this.onChangePage}
                            data={this.state.projects}
                            editable={{
                            }}
                            actions={[
                                {
                                    icon: 'edit',
                                    tooltip: 'Редактировать',
                                    isFreeAction: false,
                                    onClick: (event, rowData) => {
                                        this.handleProjectEdit(rowData);
                                    }
                                },
                            ]}
                        />}
                    </div>
                </>}
            </div>
        )
    }
}